export default {
  'curationPlatformNav.annotationTool': 'Annotation Tool',
  'curationPlatformNav.accuracyDashboard': 'Accuracy Dashboard',
};
